import axios from 'axios';

import type { AcapellaAccount, AcapellaLoginResponse } from './types';

const BASE_URL = 'https://www.acapela-cloud.com/api';

// Third-party service: own axios instance so our Authorization header and
// interceptors (set on the clients in src/utils/axios) never reach it.
const http = axios.create({ baseURL: BASE_URL });

const authHeaders = (token: string) => ({ Authorization: `Token ${token}` });

class AcapellaApi {
  async login(email: string, password: string): Promise<AcapellaLoginResponse> {
    const { data } = await http.post('/login/', { email, password });
    return data;
  }

  async logout(token: string): Promise<void> {
    await http.get('/logout/', { headers: authHeaders(token) });
  }

  async getAccount(token: string): Promise<AcapellaAccount> {
    const { data } = await http.get('/account/', {
      headers: authHeaders(token),
    });
    return data;
  }

  getTTSUrl(voice: string, text: string, speed: number, token: string): string {
    return (
      `${BASE_URL}/command/` +
      '?voice=' +
      voice +
      '&text=' +
      encodeURIComponent(text) +
      '&output=file' +
      '&type=mp3' +
      '&speed=' +
      speed * 100 +
      '&shaping=100' +
      '&volume=32768' +
      '&token=' +
      token
    );
  }

  async downloadAudio(
    voice: string,
    text: string,
    speed: number,
    token: string,
    signal?: AbortSignal,
  ): Promise<Blob> {
    const { data } = await http.get(this.getTTSUrl(voice, text, speed, token), {
      responseType: 'blob',
      signal,
    });
    return new Blob([data]);
  }
}

export const acapellaApi = new AcapellaApi();
